export enum TestConfigMenuItem {
  BASIC_SETTINGS = 'Basic Settings',
  QUESTION_MANAGER = 'Question Manager',
  ADVANCED_SETTINGS = 'Advanced Settings',
  RESPONDENT_MONITORING = 'Respondent monitoring',
  RESULTS_TABLE = 'Results table'
}
